angular.module('surfsightApp.controllers').controller('geofenceAddCtrl', [
  '$scope',
  '$timeout',
  '$interval',
  '$http',
  '$localStorage',
  '$mdDialog',
  '$mdToast',
  'dataFromCaller',
  'edgeFactoryV2',
  '$mdSidenav',
  'nominatimLookUp',
  'geofenceFactory',
  '$stateParams',
  '$filter',
  function editEdgeController (
    $scope,
    $timeout,
    $interval,
    $http,
    $localStorage,
    $mdDialog,
    $mdToast,
    dataFromCaller,
    edgeFactoryV2,
    $mdSidenav,
    nominatimLookUp,
    geofenceFactory,
    $stateParams,
    $filter
  ) {
    var $translate = $filter('translate')
    var edgeImei = $stateParams.edge_id
    $scope.edge = edgeFactoryV2.findItemByImei(edgeImei).item
    $scope.serialNumber = $scope.edge.imei
    $scope.geoJSON_data = dataFromCaller.geoJSON_data
    $scope.layerData = dataFromCaller.layerData
    $scope.fences_ids = []
    $scope.old_device = false

    $scope.addGeofence = function () {
      if ($scope.fenceName == undefined || $scope.fenceName == '') {
        return false
      }
      var geofence = {
        name: $scope.fenceName,
        lat: parseFloat($scope.geoJSON_data.geometry.coordinates[1].toFixed(6)),
        lon: parseFloat($scope.geoJSON_data.geometry.coordinates[0].toFixed(6)),
        radius: Math.ceil($scope.geoJSON_data.properties.radius),
        id: -1
      }
      $scope.saveGeoFence(geofence)
    }

    $scope.saveGeoFence = function (geofence) {
      geofenceFactory
        .addGeofence($scope.serialNumber, geofence)
        .then(function (result) {
          $scope.showMessageToast($translate('fenceAddedSuccessfully'))
          geofenceFactory.addOrUpdateItem(geofence)
          $mdDialog.hide()
        })
    }

    $scope.showMessageToast = function (message) {
      var toast = $mdToast
        .simple()
        .textContent(message)
        .action($translate('ok'))
        .position('top right')
        .actionKey('F1')
        .hideDelay(5000)

      $mdToast
        .show(toast)
        .then(function (response) {
          if (response == 'ok') {
          }
        })
        .catch(() => {})
    }
    function handleServerError (response) {
      $scope.$emit('handleServerError', response)
    }
    $scope.cancel = function () {
      $mdDialog.cancel($scope.layerData)
    }
  }
])
